import invariant from 'invariant';
import isDOMInstance from './isDOMInstance';
export default function ensureDOMInstance(node) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Node;
  !isDOMInstance(node, type) ? process.env.NODE_ENV !== "production" ? invariant(false, "An instance of ".concat(type.name, " is required, but received ").concat(node)) : invariant(false) : void 0;
}